/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Close, Favorite, FavoriteBorder, FolderOpen } from "@material-ui/icons";
import {
  Box,
  Grid,
  Avatar,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  FormControl,
  Typography,
  InputLabel,
  MenuItem,
  Select,
  withStyles,
  LinearProgress,
  Container,
  IconButton,
} from "@material-ui/core";
import { matchSorter } from "match-sorter";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { apiCall } from "../../../utils";
import { useScene } from "../../../hooks/useScene";
import { useStyles } from "./styled";
import {
  scoreInformationActions,
  userActions,
  voteActions,
} from "../../../actions";
import {
  QCV_CONFIG_CODE,
  getQcvConfig,
  isHttpUrl,
} from "../../../utils/qcv.appConfig";
import {
  APP_SCENE,
  FORM_CONSTANTS,
  PRIMARY_COLOR,
  PROFILE_API,
  ROLE,
  ROUTER,
  SECONDARY_COLOR,
} from "../../../constants";

import qcvVote from "../../../assets/image/tnv/qcv-vote.jpg";
// import backdrop from "../../../assets/image/home/backdrop.jpg";
import contract from "../../../assets/image/contract.png";
import backdrop from "../../../assets/image/banner-bg.png";
import logoDoan from "../../../assets/image/home/logoDoan.png";
import logoBoKHCN from "../../../assets/image/home/logoBoKHCN.png";
import Loading from "../../CustomComponents/Loading";
import { useScreenSize } from "../../../hooks/useScreenSize";

const fielQCVdOptions = [
  { key: "all", title: "Toàn bộ", value: "all" },
  ...FORM_CONSTANTS.FIELD_OPTIONS[APP_SCENE],
];

const fielQCVdOptionsObj = {};

fielQCVdOptions.forEach((f) => {
  fielQCVdOptionsObj[f.key] = f.title;
});

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: SECONDARY_COLOR,
  },
}))(LinearProgress);

const BinhChonV2 = () => {
  const scene = useScene();
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobileMode = useScreenSize();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const refreshToken = localStorage.getItem("refresh_token");

  const [filter, setFilter] = useState({ option: "all" });
  const [loading, setLoading] = useState(false);
  const [allProfile, setAllProfile] = useState([]);
  const [maxVote, setMaxVote] = useState(20);

  const voteInDB = useSelector((state) => state.voteReducer.votedList);
  const loadingVote = useSelector((state) => state.voteReducer.loading);

  const role = useSelector((state) => state.userReducer.user?.role);
  const profile = useSelector((state) => state.userReducer.user);
  const openSeasonId = useSelector((state) => state.seasonReducer.openSeasonId);
  const season = useSelector((state) => state.seasonReducer.season);
  // Vòng bình chọn của mùa đang mở (`seasons.vote_status`), admin đổi ở
  // Quản lý năm tổ chức.
  const defaultVoteStatus = useSelector(
    (state) => state.seasonReducer.voteStatus
  );
  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );

  // Bảng qcv_score_infos của mùa đang mở chứa dòng cấu hình link tài liệu BTC.
  // Nhánh này KHÔNG tải sẵn ở AppLayout -> màn này phải tự nạp.
  useEffect(() => {
    if (openSeasonId)
      dispatch(
        scoreInformationActions.getScoreInformationBySeasonId(openSeasonId)
      );
    // eslint-disable-next-line
  }, [openSeasonId]);

  // Link folder tài liệu Ban tổ chức - DÙNG CHUNG cho mọi ứng viên, admin tự
  // cấu hình ở trang Cấu hình hệ thống (/cau-hinh). Chưa cấu hình hoặc link
  // không phải http/https thì ẩn nút luôn.
  const btcDriveUrl = useMemo(() => {
    const url = getQcvConfig(scoreInformationList, QCV_CONFIG_CODE.BTC_DRIVE_URL);
    return isHttpUrl(url) ? url : "";
  }, [scoreInformationList]);

  const vote = useMemo(
    () =>
      voteInDB.filter((item) => {
        const form = allProfile.find((f) => {
          const fVoteStatus = f.voteStatus || "";
          const itemType = item.type || "";
          return f.id === item.applicationFormId && fVoteStatus === itemType;
        });
        return !!form;
      }),
    [voteInDB, allProfile]
  );

  const fieldOptions = useMemo(
    () => [
      { key: "all", title: "Toàn bộ", value: "all" },
      ...FORM_CONSTANTS.FIELD_OPTIONS[APP_SCENE],
    ],
    [scene]
  );

  // Vòng bình chọn ĐỌC TỪ DB (`seasons.vote_status`) thay vì hardcode, để admin
  // đổi được trên giao diện. Mỗi cổng giữ một MẶC ĐỊNH đúng bằng giá trị đang
  // hardcode trước đây -> mùa nào chưa set vote_status thì hành vi không đổi.
  // Số phiếu tối đa gắn liền với vòng: top20 = 20 phiếu, top10 = 10 phiếu.
  const voteStatus = useMemo(() => {
    const roundOf = (fallback) => {
      // Chỉ nhận 2 giá trị hợp lệ; dữ liệu rỗng/rác -> dùng mặc định của cổng.
      const round =
        defaultVoteStatus === "top10" || defaultVoteStatus === "top20"
          ? defaultVoteStatus
          : fallback;
      setMaxVote(round === "top20" ? 20 : 10);
      return round;
    };

    if (scene.isQuaCauVang) return roundOf("top10");
    if (scene.isGiaiThuongNuSinh) return roundOf("top20");
    if (scene.isKhueVanCac) return roundOf("top20");
    return undefined;
  }, [scene, defaultVoteStatus]);

  // Thứ tự PHẢI GIỐNG màn /danh-sach-ho-so nên dùng đúng pipeline của màn đó
  // (GTNS: containers/GTNS/DanhSachHoSo/DanhSachHoSoTable; QCV: components/QCV/
  // DanhSachHoSo/DanhSachHoSo): matchSorter theo `profile.name` rồi mới lọc
  // lĩnh vực. Với query rỗng, matchSorter xếp tên A->Z (baseSort mặc định của
  // match-sorter) - chính là thứ tự đang hiện ở màn danh sách hồ sơ.
  //
  // Trước đây ở đây tự sort lại: "Toàn bộ" theo `id` tăng dần, còn lọc theo
  // lĩnh vực thì theo `scoreG` -> lệch hẳn với màn danh sách, và `.sort()` còn
  // mutate thẳng mảng state.
  const profiles = useMemo(() => {
    const sorted = matchSorter(allProfile, "", { keys: ["profile.name"] });
    return filter.option === "all"
      ? sorted
      : sorted.filter((p) => p.field === filter.option);
  }, [filter.option, allProfile]);

  const checkVoted = (p) => {
    const isVoted = !!vote?.find((v) => v.applicationFormId === p.id);
    return isVoted;
  };

  const noti = (notification) => {
    enqueueSnackbar(notification?.message, {
      variant: notification?.type || "default",
      action: (key) => (
        <IconButton size="small" onClick={() => closeSnackbar(key)}>
          <Close size="small" style={{ color: "white" }} />
        </IconButton>
      ),
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  };

  const handleFilter = async () => {
    const api = PROFILE_API.getProfileFilterForm();

    setLoading(true);

    const { response, error } = await apiCall({
      ...api,
      payload: {
        seasonId: openSeasonId,
        category: APP_SCENE,
        voteStatus,
        status: ["approved"],
      },
    });
    setLoading(false);
    if (!error && response.status === 200 && response.data.success) {
      setAllProfile(response.data.data || []);
    }
  };

  const handleGetVote = () => {
    const voteInfo = {
      credential: profile?.username,
      type: "council",
    };

    dispatch(voteActions.getVoteInfo({ credential: voteInfo?.credential }));
    dispatch(voteActions.setVoteInfo(voteInfo));
    dispatch(voteActions.getVoteCount());
  };

  const handleVote = (profileVote) => {
    if (season.regOpenAt && dayjs().isBefore(dayjs(season.regOpenAt))) {
      return noti({
        message: `Chưa đến thời gian bình chọn!`,
        type: "warning",
      });
    }
    const oldVotes = vote?.map((v) => v.applicationFormId);
    const voteInfo = {
      credential: profile?.username,
      type: voteStatus,
      listFormId: [...oldVotes, profileVote.id],
    };

    if (voteInfo.listFormId.length > maxVote) {
      noti({
        message: `Chỉ được bình chọn tối đa ${maxVote} ứng viên!`,
        type: "error",
      });
    } else {
      dispatch(
        voteActions.vote(voteInfo, () => {
          handleGetVote();
          noti({ message: "Bình chọn thành công!", type: "success" });
        })
      );
    }
  };

  // Bấm vào thẻ/ảnh ứng viên -> mở hồ sơ để đọc trước khi bỏ phiếu. Hội đồng
  // bình chọn vào trang hồ sơ ở chế độ CHỈ ĐỌC (xem components/*/HoSo/HoSo.js).
  const openProfile = (p) => navigate(`${ROUTER.HO_SO}/${p.id}`);

  const handleUnVote = (profileVote) => {
    const oldVotes = vote?.map((v) => v.applicationFormId);
    const newVotes = oldVotes.filter((v) => v !== profileVote.id);
    const voteInfo = {
      credential: profile?.username,
      type: voteStatus,
      listFormId: [...newVotes],
    };

    dispatch(
      voteActions.vote(voteInfo, () => {
        handleGetVote();
        noti({ message: "Bỏ bình chọn thành công", type: "success" });
      })
    );
  };

  useEffect(() => {
    if (openSeasonId && voteStatus) {
      handleGetVote();
      handleFilter();
    }
  }, [openSeasonId, voteStatus, profile]);

  useEffect(() => {
    if (
      !refreshToken ||
      (role &&
        role !== ROLE.SUPER_ADMIN &&
        role !== ROLE.COUNCIL &&
        role !== ROLE.COUNCIL_QCV &&
        role !== ROLE.COUNCIL_GTNS &&
        role !== ROLE.COUNCIL_KVC)
    ) {
      navigate(ROUTER.PAGE_401);
    }
  }, [role]);

  return (
    <>
      <Container maxWidth="lg">
        <Box className={classes.imageHead}>
          <Box className={classes.logoHeader}>
            <Box mr={"40px"} className="group-logo">
              <img width={80} src={logoDoan} style={{ margin: "auto" }} />
              <Typography variant="h6">
                TRUNG ƯƠNG ĐOÀN TNCS HỒ CHÍ MINH
              </Typography>
            </Box>
            <Box className="group-logo">
              <img width={80} src={logoBoKHCN} />
              <Typography variant="h6">BỘ KHOA HỌC VÀ CÔNG NGHỆ</Typography>
            </Box>
          </Box>
        </Box>

        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          className={classes.filter}
        >
          <Grid item xs={12} md={6} lg={4}>
            <Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
              <Button
                color="secondary"
                variant="contained"
                disabled={role !== "super_admin"}
                onClick={() => navigate(ROUTER.QCV.KET_QUA_BINH_CHON)}
              >
                Xem kết quả bình chọn (admin)
              </Button>
              {!!btcDriveUrl && (
                <Button
                  color="primary"
                  variant="contained"
                  startIcon={<FolderOpen />}
                  onClick={() =>
                    window.open(btcDriveUrl, "_blank", "noopener,noreferrer")
                  }
                >
                  Tài liệu Ban tổ chức
                </Button>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl size="small" variant="outlined" fullWidth>
              <InputLabel id="test-select-label">Lĩnh vực</InputLabel>
              <Select
                fullWidth
                value={filter.option}
                MenuProps={{
                  getContentAnchorEl: null,
                  MenuListProps: { style: { padding: 0 } },
                  PaperProps: { style: { left: 8 } },
                  anchorOrigin: { vertical: "bottom", horizontal: "center" },
                  transformOrigin: { vertical: "top", horizontal: "center" },
                }}
                onChange={(e) =>
                  setFilter({ ...filter, option: e.target.value })
                }
                label="Lĩnh vực"
              >
                {fieldOptions?.map((opt) => (
                  <MenuItem key={opt.key} value={opt.key}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ minHeight: "100vh" }}>
          {profiles.map((p, index) => {
            return (
              <Grid
                item
                md={4}
                xs={12}
                key={index}
                classes={{ root: classes.gridCard }}
                style={{ height: "100%" }}
              >
                <Card style={{ borderRadius: 8 }}>
                  <CardActionArea
                    className="card-area"
                    onClick={() => openProfile(p)}
                  >
                    <CardMedia
                      component="img"
                      classes={{ root: classes.header }}
                      src={qcvVote}
                    />
                    <Avatar
                      src={`${process.env.REACT_APP_DOMAIN}${p?.profile?.photoUrl}`}
                      style={{
                        width: 100,
                        height: 100,
                        border: "solid 4px #fff",
                        margin: "-50px auto 0 auto",
                      }}
                    />
                    <CardContent
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        height: "125px",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "1.3rem",
                          marginBottom: "20px",
                          fontWeight: "bold",
                          fontFamily: "WorkSans-ExtraBold",
                        }}
                      >
                        {p.profile.name}
                      </Typography>
                      <Box className={classes.info}>
                        <Typography
                          style={{ width: "100%", textAlign: "center" }}
                        >
                          <b>Lĩnh vực: </b>
                          {fielQCVdOptionsObj[p.field]}
                        </Typography>
                        <Typography
                          style={{ width: "100%", textAlign: "center" }}
                        >
                          <b>Ngày sinh: </b>
                          {dayjs(p?.profile?.birth).format("DD/MM/YYYY")}
                        </Typography>
                      </Box>
                    </CardContent>
                    <Box className={classes.vote}>
                      <Button
                        style={{
                          backgroundColor: checkVoted(p)
                            ? "#EE6064"
                            : undefined,
                          color: checkVoted(p) ? "#FFFFFF" : undefined,
                          border: checkVoted(p) ? "0px" : undefined,
                          margin: "auto",
                        }}
                        startIcon={
                          checkVoted(p) ? (
                            <Favorite color="#FFFFFF" />
                          ) : (
                            <FavoriteBorder />
                          )
                        }
                        onClick={(e) => {
                          // Chặn bubble lên CardActionArea (đang mở hồ sơ).
                          e.stopPropagation();
                          checkVoted(p) ? handleUnVote(p) : handleVote(p);
                        }}
                      >
                        {checkVoted(p) ? "Đã bình chọn" : "Bình chọn"}
                      </Button>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        <Loading open={loading || loadingVote} />
      </Container>

      <Box mt={4} className={classes.bottom}>
        <Container maxWidth="md">
          <Card
            style={{
              backgroundImage: `url(${backdrop})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: isMobileMode ? 96 : 128,
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              style={{ height: isMobileMode ? 96 : 128 }}
            >
              <Box paddingLeft={isMobileMode ? 2 : 4}>
                <Box
                  flexGrow={1}
                  marginBottom={1}
                  display="flex"
                  alignItems="center"
                >
                  <Typography
                    variant={isMobileMode ? "body1" : "h4"}
                    style={{ color: PRIMARY_COLOR }}
                  >
                    <b>Đã bình chọn: </b>
                  </Typography>
                  <Typography
                    variant={isMobileMode ? "h6" : "h3"}
                    style={{
                      color: PRIMARY_COLOR,
                      fontFamily: "WorkSans-ExtraBold",
                    }}
                  >
                    <b>
                      <>&nbsp;</>
                      <span style={{ color: SECONDARY_COLOR }}>
                        {vote?.length}
                      </span>
                      /{maxVote}
                    </b>
                  </Typography>
                </Box>
                <BorderLinearProgress
                  variant="determinate"
                  value={(vote?.length / maxVote) * 100}
                  style={{ width: "125%" }}
                />
              </Box>
              <Box
                height="100%"
                paddingTop={2}
                paddingRight={isMobileMode ? 2 : 4}
              >
                <img alt="contract" src={contract} style={{ height: "100%" }} />
              </Box>
            </Box>
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default BinhChonV2;
